import type { RegisteredServices } from '@/core/container/types'

import type { TmWrappers } from '@/wrappers'

export const carrierLookupDetailsModalId: TmWrappers = 'carrierLookupDetailsModal'

export const emailLookupDetailsModalId: TmWrappers = 'emailLookupDetailsModal'

export const AutomationRulesLogsTable = 'AutomationRulesLogsTable' as RegisteredServices

export const CarrierLookupHistoryTableId = 'CarrierLookupHistoryTable' as RegisteredServices

export const DistributionsTable = 'DistributionsTable' as RegisteredServices
